// Checkout.js
import { LuMoveLeft } from "react-icons/lu"
import QRCode from "react-qr-code"
import { Outlet, useLocation, useParams } from "react-router-dom"
import { useNavigate } from "react-router-dom"

import BackgroundWrapper from "@fuse/sharedComponents/backgroundWrapper"
import BlurWrapper from "@fuse/sharedComponents/blurWrapper"
import Navbar from "@fuse/sharedComponents/navbar/Navbar"
import FancyText from "@fuse/sharedComponents/typography/FancyText"
import { get } from "lodash-es"
import { useRecoilState } from "recoil"
import { ROUTES } from "src/App"

import { userState } from "@fuse/recoil/signup"

import { useEventDetails } from "@api/services/events/useEventsApi"

const MyEventTicket = () => {
  const params = useParams()
  const eventId = get(params, "eventId", "")
  const { state } = useLocation()
  const { data: eventData, isLoading: eventLoading } = useEventDetails(eventId)
  const [user] = useRecoilState(userState)
  const navigate = useNavigate()

  const currentEventDetails = get(state || eventData, "data", {})

  const flyerImage = get(currentEventDetails, "eventDocData.flyerImage", "")

  const handleBackPress = () => {
    // navigate(ROUTES.EVENTS.replace(":eventId", eventId))
    navigate(-1)
  }

  const HeaderMobile: React.FC = () => {
    return (
      <div className="mt-4 ml-4 md:mt-12 md:ml-12 flex items-center space-x-2 z-10  sm:hidden ">
        <div
          onClick={handleBackPress}
          className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 rounded-full flex justify-center items-center bg-white/10 cursor-pointer z-10 "
        >
          <LuMoveLeft className="text-white text-md md:text-2xl" />
        </div>
        <div className="flex w-full items-center justify-center absolute left-[-8px]">
          <p className="text-md md:text-[26px] font-semibold text-white">
            My ticket
          </p>
        </div>
      </div>
    )
  }

  const Header: React.FC = () => {
    return (
      <div
        className={`w-full items-center justify-center relative z-[100] hidden sm:flex`}
      >
        <header className="flex w-full justify-between items-center self-center px-4 md:px-8 py-6 max-w-screen-xl 2xl:max-w-screen-2xl">
          <div
            onClick={handleBackPress}
            className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 rounded-full flex justify-center items-center bg-white/10 cursor-pointer"
          >
            <LuMoveLeft className="text-white text-md md:text-2xl" />
          </div>
        </header>
      </div>
    )
  }

  return (
    <BackgroundWrapper bgImage={flyerImage} className="min-h-screen">
      <BlurWrapper
        overlayOpacityDefault="75"
        overlayColorDefault="dark"
        className="min-h-screen"
      >
        {/* {isLoading && <LoadingSpinner />} */}
        <Navbar className="hidden sm:block" />
        <HeaderMobile />
        <Header />
        <div className="flex flex-1 flex-col items-center justify-center w-full lg:px-8">
          <div className="flex flex-1 flex-col w-full">
            <div className="w-full md:max-w-full">
              <div className="flex flex-col items-center justify-center w-full h-[80%] mx-auto">
                <div className="flex flex-col w-full max-w-xs items-center justify-center">
                  <p className="text-white text-left text-[12px] md:text-lg lg:text-2xl font-semibold hidden sm:block">
                    My ticket
                  </p>
                </div>

                <Outlet />

                {/* <AbstractcardOfTicket /> */}
              </div>
            </div>
          </div>
        </div>
      </BlurWrapper>
    </BackgroundWrapper>
  )
}

export default MyEventTicket
